import classNames from "classnames";
import { Controller } from "react-hook-form";
import { Navigation, Mousewheel } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

type ImageSlideProps = {
  name: string;
  control: any;
  slides: { id: string; url: string }[];
  draggable?: boolean;
  slidesPerView?: number;
  containerClassName?: string;
  spaceBetweenSliders?: number;
};

const ImageSlider = ({
  slides,
  name,
  control,
  draggable,
  slidesPerView = 4,
  containerClassName,
  spaceBetweenSliders = 10,
}: ImageSlideProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        return (
          <Swiper
            navigation
            slidesPerView={slidesPerView}
            modules={[Navigation, Mousewheel]}
            spaceBetween={spaceBetweenSliders}
            scrollbar={{ draggable: draggable }}
          >
            {slides.map((slide, idx) => (
              <SwiperSlide
                key={idx}
                onClick={() => field.onChange({ ...slide })}
                className={classNames("", containerClassName)}
              >
                <div
                  className={classNames(
                    "h-[140px] p-[2px] border-2 border-transparent cursor-pointer transition-all",
                    {
                      "!border-primary": field?.value?.url === slide.url,
                      "hover:border-grey-light": field.value?.url !== slide.url,
                    },
                  )}
                >
                  <img
                    className="object-cover w-full h-full"
                    src={slide.url}
                    alt=""
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        );
      }}
    />
  );
};

export default ImageSlider;
